import { render } from "./ResendDocumentEdi.vue?vue&type=template&id=a37e24ee&scoped=true"
import script from "./ResendDocumentEdi.vue?vue&type=script&lang=js"
export * from "./ResendDocumentEdi.vue?vue&type=script&lang=js"

import "./ResendDocumentEdi.vue?vue&type=style&index=0&id=a37e24ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37e24ee"]])

export default __exports__